import { Controller } from "@hotwired/stimulus"

// Copies one date field's value into another within the same form.
//
// Replaces the handleStartDateChange method that used to live on the shared datepicker
// controller with `#site_end_date` hardcoded into it — a form-specific rule sitting in the
// control every date field in the app used.
//
// Put the controller on the form and the action on the source field:
//
//   data: { action: 'change->linked-date#copy', 'linked-date-to-param': 'site[end_date]' }
//
// The destination is matched by form field name. Writing to it and dispatching `change` is
// what the date-picker controller listens for, so its visible input follows along.
export default class extends Controller {
  copy(event) {
    const name = event.params.to
    if (!name) return

    const destination = this.element.querySelector(`input[name="${name}"]`)
    if (!destination || destination === event.target) return

    destination.value = event.target.value
    destination.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
